import React from 'react'
import FormErrorMessage, {MessagePair} from '../FormErrorMessage'
import {LeftColumnFlexContainer} from '../../../../styledComponents/FlexComponents'

interface ExternalProps {
    messages?: MessagePair[]
}

export interface ErrorMessageProps {
    messages?: MessagePair[]
}

export const withErrorMessage = <OriginalProps extends {}>(
    WrappedComponent: React.ComponentType<OriginalProps & ErrorMessageProps>,
) => {

    type ResultProps = OriginalProps & ExternalProps;

    const WithErrorMessage = (props: ResultProps) => {
        const hasError: boolean = props.messages && props.messages.length > 0 || false
        return (<>
            <LeftColumnFlexContainer className={'withErrorMessage'}>
                <WrappedComponent hasError={hasError} {...props}/>
                {
                    hasError &&
                    <FormErrorMessage
                        messages={props.messages}
                        onClick={event => event.preventDefault()}
                    />
                }
            </LeftColumnFlexContainer>
        </>)
    }
    WithErrorMessage.displayName = `withErrorMessage(${WrappedComponent.displayName})`
    return WithErrorMessage
}
